import MatterTasksCard from "@/components/features/matter/tasks/MatterTasksCard";
import { Card, CardContent, Typography } from "@/components/ui";
import LawWorksLoader from "@/components/ui/LawWorksLoader/LawWorksLoader";
import { retrieveMassTortQueryOptions } from "@/lib/data/react-query/mass-torts/mass-tort";
import { getMassTortAnnotationMatter } from "@/lib/utils/massTortAnnotationUtils";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useSearch } from "@tanstack/react-router";
import { useMemo } from "react";
import { z } from "zod";

export const Route = createFileRoute(
  "/_auth/mass-torts/$massTortSearchId/_layout/tasks",
)({
  component: RouteComponent,
  validateSearch: z.object({
    taskId: z.string().optional(),
  }),
});

function RouteComponent() {
  const { massTortSearchId: massTortId } = Route.useParams();
  const { taskId } = useSearch({
    from: "/_auth/mass-torts/$massTortSearchId/_layout/tasks",
  });
  const { data: massTortResponse, isLoading: isMassTortLoading } = useQuery({
    ...retrieveMassTortQueryOptions(massTortId),
  });

  const massTort = massTortResponse?.data;
  const annotationMatter = useMemo(
    () => getMassTortAnnotationMatter(massTort),
    [massTort],
  );
  const isPageLoading = Boolean(massTortId && isMassTortLoading);

  if (isPageLoading) {
    return <LawWorksLoader className="w-full" />;
  }

  if (!massTortId || !massTort) {
    return (
      <div className="grid h-screen w-full grid-cols-1 gap-4 p-6">
        <Card className="flex h-full flex-col">
          <CardContent className="flex h-full flex-col items-center justify-center gap-2 text-center">
            <Typography variant="subHeading">Mass tort tasks</Typography>
            <Typography className="text-muted-foreground">
              Unable to load tasks for this mass tort.
            </Typography>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <MatterTasksCard
      tasks={[]}
      matter={annotationMatter}
      massTortId={massTortId}
      taskId={taskId}
    />
  );
}
